module.exports = __webpack_public_path__ + "static/media/video-advmindfulness-threats-es.d77cb900.vtt";